import {Pipe, PipeTransform} from '@angular/core';
import {TableAction} from '../dto/data-table-structure/table-action';

@Pipe({name: 'hasVisibleActions', pure: true})
export class HasVisibleActionsPipe implements PipeTransform {
    transform(actions: TableAction[], row: any): boolean {
        return actions.some(action => {
            if (typeof action.isHidden === 'function') {
                return !action.isHidden(row);
            }
            return !action.isHidden;
        });
    }
}
